import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@chakra-ui/react";

import { useAppModal } from "../../Modals";
import { RoutesMap } from "../../../../routes.tsx";
import { CoolingPageModal } from "../Modal/CoolingPageModal";

export const CoolingPageButtons: FC = () => {
  const navigate = useNavigate();
  const { showModal, hideModal } = useAppModal();

  const onHomeClick = () => {
    navigate(RoutesMap.index);
  };

  const onRefusalClick = () => {
    showModal({
      header: "Отказаться от выдачи",
      content: (_, block) => <CoolingPageModal hideModal={hideModal} blockModalClosing={block} />,
    });
  };

  return (
    <Stack spacing="6px" w="100%" mt="12px">
      <Button colorScheme="purple" onClick={onHomeClick}>Вернуться на главную</Button>
      <Button onClick={onRefusalClick}>Отказаться от выдачи</Button>
    </Stack>
  );
};
